module.exports = __webpack_public_path__ + "static/media/Covert_Commands_Body_Writing.c5989c13.mp3";